const Counter = ({ count }) => {
  return <div>Всего кликов: {count}</div>;
};

export default Counter;
